<template>
  <BfSlideOutNav
    :is-open="isMobileNavOpen"
    :nav-items="navItems"
    @close-nav="closeNav"
  />
</template>

<script>
import { mapState } from 'vuex';
import { CLOSE_NAV } from '@/store/modules/mobileNav';

export default {
  name: 'MobileSideNav',

  props: {
    navItems: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    closeNav() {
      this.$store.dispatch(`mobileNav/${CLOSE_NAV}`);
    },
  },

  computed: {
    ...mapState({
      isMobileNavOpen: ({ mobileNav }) => mobileNav.isOpen,
    }),
  },
};
</script>
